import { Route } from 'config/routes';
import { call, fork, put, select } from 'redux-saga/effects';
import {
  isAgentManagerSelector,
  approvedAgentSelector,
} from 'store/state/domainData/selectors';
import { navigateTo } from 'store/state/router/actions';
import { showAgentConsoleBulletinFormSelector } from 'store/state/selectors/router';
import { resetDomainData } from 'store/state/domainData/actions';
import { LoadOptions, LoadType } from 'store/sagas/apiService/types';
import { queryData } from 'store/sagas/apiService';

function* bulletinFormWorker() {
  const isApprovedAgent: boolean = yield select(approvedAgentSelector);
  const isAgentManager: boolean = yield select(isAgentManagerSelector);
  const isConsoleUser: boolean = yield select(showAgentConsoleBulletinFormSelector);

  if (!isConsoleUser) {
    yield put(navigateTo(Route.Home, {}, { replace: true }));
  }
  else {
    if (isApprovedAgent || isAgentManager) {
      yield put(resetDomainData({ loadType: LoadType.GetBulletinsUsageOverview }));

      const getUsageOverviewOptions: LoadOptions<LoadType.GetBulletinsUsageOverview> = {
        loadType: LoadType.GetBulletinsUsageOverview,
        meta: {
          variables: {},
        },
      };

      yield fork(queryData, getUsageOverviewOptions);
    }
  }
}

export function* bulletinFormPageHandler() {
  yield call(bulletinFormWorker);
}
